<template>
  <div class="account-container">
    <!-- 顶部用户信息 -->
    <div class="header">
      <div class="user-info">
        <img v-if="profileData.avatar" :src="profileData.avatar" alt="user" class="avatar" />
        <img v-else src="@/assets/user.png" alt="user" class="avatar" />
        <div class="user-text">
          <div class="username">{{ profileData.first_name }}</div>
          <div v-if="profileData.user_type === 1" class="user-id">{{ '账户' + (currentAccount + 1) }}</div>
          <div v-if="profileData.user_type === 0 || profileData.user_type === 2" class="user-id">{{ currentAccount }}
          </div>
        </div>
      </div>
    </div>

    <!-- 菜单列表 -->
    <div class="menu-card">
      <div class="menu-item" @click="handleMenuClick('fund')">
        <div class="menu-left">
          <img src="../assets/fund-icon.png" alt="fund" class="menu-icon" />
          <span class="menu-text">基金管理要素</span>
        </div>
        <img src="../assets/right-icon.png" alt="arrow" class="arrow-icon" />
      </div>

      <div class="menu-divider"></div>

      <div class="menu-item" @click="handleMenuClick('increase')">
        <div class="menu-left">
          <img src="../assets/assets-icon.png" alt="increase" class="menu-icon" />
          <span class="menu-text">增减资详情</span>
        </div>
        <img src="../assets/right-icon.png" alt="arrow" class="arrow-icon" />
      </div>

      <div class="menu-divider"></div>

      <div class="menu-item" @click="handleMenuClick('report')">
        <div class="menu-left">
          <van-icon class="menu-icon" name="column" color="#32d5ae" size="24"/>
          <span class="menu-text">每月月报</span>
        </div>
        <img src="../assets/right-icon.png" alt="arrow" class="arrow-icon" />
      </div>

      <div class="menu-divider"></div>

      <div class="menu-item" @click="handleMenuClick('settings')">
        <div class="menu-left">
          <img src="../assets/setting-icon.png" alt="settings" class="menu-icon" />
          <span class="menu-text">账号设置</span>
        </div>
        <img src="../assets/right-icon.png" alt="arrow" class="arrow-icon" />
      </div>
    </div>

    <!-- 退出登录按钮 -->
    <div class="logout-button" @click="handleLogout">
      退出登录
    </div>

    <!-- 底部导航 -->
    <BottomNav />
  </div>
</template>

<script>
import BottomNav from '@/components/BottomNav.vue';
import { Dialog } from 'vant';

export default {
  name: 'Account',
  components: {
    BottomNav
  },
  data() {
    return {
      profileData: {
        avatar: '',
        bind_name: '',
        date_joined: '',
        first_name: '',
        id: '',
        name: '',
        phone: '',
        user_type: '',
        username: ''
      },
      accountData: [],
      currentAccount: ''
    }
  },
  mounted() {
    this.profileData = localStorage.getItem('profileData') ? JSON.parse(localStorage.getItem('profileData')) : {};
    if (this.profileData.bind_name) {
      this.accountData = this.profileData.bind_name.split(',')
      if (this.profileData.user_type === 1) {
        this.currentAccount = this.accountData.findIndex(item => item === this.profileData.name)
      }
      else if (this.profileData.user_type === 0 || this.profileData.user_type === 2) {
        this.currentAccount = this.profileData.name
      }
    }
  },
  methods: {
    handleMenuClick(type) {
      switch (type) {
        case 'fund':
          this.$router.push('/fund-management');
          break;
        case 'increase':
          this.$router.push('/capital-change-detail');
          break;
        case 'report':
          this.$router.push('/report');
          break;
        case 'settings':
          this.$router.push('/settings');
          break;
      }
    },
    handleLogout() {
      Dialog.confirm({
        title: '提示',
        message:
          '是否确定退出登录?',
      })
        .then(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('profileData');
          this.$router.push('/login');
        }).catch(() => {

        })
    }
  }
};
</script>

<style scoped>
.account-container {
  width: 100%;
  min-height: 100vh;
  background-color: #000;
  color: #fff;
  padding: 20px 20px 80px;
  overflow: auto;
}

/* 顶部用户信息 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.user-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.username {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.user-id {
  font-size: 12px;
  color: #999;
}

/* 菜单卡片 */
.menu-card {
  background-color: #1a1a1a;
  border-radius: 16px;
  padding: 0 20px;
  margin-bottom: 40px;
}

.menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.menu-item:active {
  opacity: 0.7;
}

.menu-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.menu-icon {
  width: 24px;
  height: 24px;
}

.menu-text {
  font-size: 15px;
  color: #fff;
}

.arrow-icon {
  width: 16px;
  height: 16px;
  opacity: 0.5;
}

.menu-divider {
  height: 1px;
  background-color: #2a2a2a;
}

/* 退出登录按钮 */
.logout-button {
  width: 100%;
  height: 50px;
  background-color: #36D8AF;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  color: #000;
  cursor: pointer;
  transition: opacity 0.3s ease;
  position: fixed;
  bottom: 100px;
  left: 20px;
  right: 20px;
  width: calc(100% - 40px);
}

.logout-button:active {
  opacity: 0.8;
}
</style>
